import {Outlet, useLocation} from 'react-router'

import {routerPaths} from '@routes'
import {Footer} from '@product/quies/components/Footer/Footer'
import {InterfaceLanguage} from '@product/quies/i18n/catalogue'
import {detectLangFromPath} from '@product/quies/lib/hreflang'
import styles from '@product/quies/styles/_layout.module.scss'

export default function Layout() {
    // "No footer on the session page: the path ends where the person is" (pages/session/spec.md
    // § Sections and hierarchy).
    const {pathname} = useLocation()
    const isSession = pathname === routerPaths['/session']

    return (
        <InterfaceLanguage.Provider value={detectLangFromPath(pathname.toLowerCase())}>
            <div className={styles.Layout}>
                <Outlet/>
                {!isSession && <Footer/>}
            </div>
        </InterfaceLanguage.Provider>
    )
}
